import React from 'react';

import { type TypeTextProps } from '@thefarmersfront/kitchen';

import styles from './Link.module.scss';

type LinkProps = {
  text: string;
  href: string;
  size?: TypeTextProps['size'];
  target?: '_self' | '_blank' | '_parent' | '_top';
};

const Link = ({ text, href, size = 'large', target = '_self' }: LinkProps) => {
  return (
    <a
      className={`${styles['link']}
      ${size ? styles[`text-size-${size}`] : ''}
      `}
      href={href}
      target={target}
      rel={target === '_blank' ? 'noopener,noreferrer' : undefined}
    >
      {text}
    </a>
  );
};

export default Link;
